import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { EncartMiseEnAvant } from '@components/encart-mise-en-avant/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-encart-mise-en-avant',
  imports: [TitleComponent, ImageComponent, ButtonComponent],
  templateUrl: './encart-mise-en-avant.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EncartMiseEnAvantComponent extends AbstractDynamicComponent<EncartMiseEnAvant> {}
